import { FooterDefinition } from '@pegasus/ui-footers';

import { CONTENTFUL_API_PREFIX } from 'src/shared/constants';

import { assertStatusCode, createRestClient } from '../restClient';

export interface Response {
    results: FooterDefinition;
}

const client = createRestClient(CONTENTFUL_API_PREFIX, '/unify-footers');

export const fetchFooter = (locale: string): Promise<Response> => {
    return client
        .get(`/${locale}`)
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .then(data => ({
            results: data,
        }));
};
